import { ActivityRedirector } from "./activity-redirector.page";

export default ActivityRedirector;
